<template>
    <router-link
            :style="{ color, borderColor: color }"
            :class="className"
            class="btn"
            v-if="to && !disabled"
            :to="to">
        <slot></slot>
    </router-link>
    <a :style="{ color, borderColor: color }"
       :class="className"
       class="btn"
       v-else-if="href && !disabled"
       :href="href">
        <slot></slot>
    </a>
    <button
            :style="{ color, borderColor: color }"
            :disabled="disabled"
            :class="className"
            class="btn"
            v-else
            @click="$emit('click', $event)">
        <slot></slot>
    </button>
</template>

<script>
export default {
    props: {
        to: {
            type: Object
        },
        href: {
            type: String
        },
        disabled: {
            default: false,
            type: Boolean
        },
        inverse: {
            default: false,
            type: Boolean
        },
        color: {
            default: '',
            type: String
        },
        btnType: {
            type: String,
            default: ''
        }
    },
    computed: {
        className () {
            const inverse = this.inverse ? 'btn-primary' : 'btn-outline-primary'
            return `${inverse} ${this.btnType}`
        }
    }
}
</script>

<style scoped>

</style>
